module.exports = __webpack_public_path__ + "img/36_28.a1b1f761.png";